"use strict";

AquaTechTheme.registerModule('slick', '//aquatech.net/cdn/shop/t/131/assets/slick.min.js?v=137854379748585577071763751218', () => {
    var $ = AquaTechTheme.$;

    AquaTechTheme.Slick = {
        onDocReady: function() {
            var self = AquaTechTheme;

            if (self.pageIs.product) {
              var $productSlider = $('.product-images-container .product-medias__with-thumbnails.product-medias__with-thumbnails--below .product-medias__thumbnails');
              $productSlider.slick({
                dots: true,
                infinite: false,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 3,
                adaptiveHeight: true,
                prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor" class="chevron-left" style="max-height:18px;"><path d="M.7 256l22.6 22.6 160 160L206 461.3 251.3 416l-22.6-22.6L91.3 256 228.6 118.6 251.3 96 206 50.7 183.4 73.4l-160 160L.7 256z"></path></svg></button>',
                nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor" class="chevron-right" style="max-height:18px;"><path d="M283.3 256l-22.6 22.6-160 160L78 461.3 32.7 416l22.6-22.6L192.7 256 55.4 118.6 32.7 96 78 50.7l22.6 22.6 160 160L283.3 256z"></path></svg></button>'
              });
            }

            self.dlog('AquaTechTheme.Slick onDocReady()');
        }
    }
    // Icons: Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc.

    AquaTechTheme.$(function() { AquaTechTheme.Slick.onDocReady(); });
});
